// import 'babel-polyfill'
import objectFitImages from 'object-fit-images'
import 'jquery-match-height/jquery.matchHeight'
import '@fancyapps/fancybox'
import 'what-input'
import './selects'
import './front-page'
import './header'
import './content'
import './load-more'
import './popup'
import './product-gallery'

objectFitImages()

jQuery.fancybox.defaults.animationEffect = 'fade'
jQuery.fancybox.defaults.gash = false
jQuery.fancybox.defaults.buttons = [
    'close'
]
jQuery.fancybox.defaults.clickContent = false

jQuery( '[data-fancybox="popup"]' ).fancybox({
    arrows : false,
})

jQuery(document).ready(function () {


})

jQuery(document).on('gform_confirmation_loaded', function(event, formId){
    jQuery('body').addClass( 'gform-confirmation-displaying' )
})

// Trigger Product Modal
jQuery( '.woocommerce-LoopProduct-link, .featured .product__figure, .featured .product__title' ).on( 'click', function(e){

    e.preventDefault()

    jQuery.fancybox.open({
        //modal     : true,
        src       : jQuery( this ).data('src'),
        autoFocus : false,
        // beforeShow: function(){
        //     jQuery("body").css({'overflow-y':'hidden','height':'100vh'});
        // },
        afterClose: function() {

            jQuery( '.woocommerce-LoopProduct-link[data-src="#'+ jQuery( this )[0].$content.attr('id') +'"]' ).focus()

            jQuery("body").css({'overflow-y':'visible','height':'auto'});

        },
        touch : false,
        btnTpl : {
            smallBtn :
                '<button data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}" aria-label="Close modal">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><title>Close Modal</title><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" /></svg>' +
                "</button>"
        },
        baseTpl:
          '<div class="fancybox-container" role="dialog" tabindex="-1" aria-modal="true" aria-label="Speakers modal window">' +
          '<div class="fancybox-bg"></div>' +
          '<div class="fancybox-inner">' +
          '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
          '<div class="fancybox-toolbar">{{buttons}}</div>' +
          '<div class="fancybox-navigation">{{arrows}}</div>' +
          '<div class="fancybox-stage"></div>' +
          '<div class="fancybox-caption"><div class=""fancybox-caption__body"></div></div>' +
          '</div>' +
          '</div>',
    })

    console.log(this.id);     

    var gallerySlider = jQuery('#p_'+this.id),
    gallerySlides = jQuery('.gallery__holder .gallery-item')
    if (gallerySlider.length > 0 && gallerySlides.length > 1) {

        gallerySlider.flickity({
            cellSelector: '.gallery-item',
            prevNextButtons: true,
            autoPlay: false,
            wrapAround: true,
            pageDots: true,
            cellAlign: 'left',
            contain: true,
            arrowShape: {
                x0: 10,
                x1: 60, y1: 50,
                x2: 65, y2: 45,
                x3: 20
            }
        })

               

    }


    

})

jQuery(document).on('change', '.product__cart-wrapper input.qty', function() {

    jQuery(this).parent().parent().find('a.ajax_add_to_cart').attr('data-quantity', jQuery(this).val());

});

jQuery( document.body ).on( 'added_to_cart', function(){

    setTimeout( function(){

        jQuery( '.add_to_cart_button.added' ).text( 'Added' )

        setTimeout( function(){

            jQuery( '.add_to_cart_button.added' ).text( 'Add to cart' ).removeClass( 'added' )

        }, 5000 )

    }, 1 )

})

jQuery( '.product .quantity input, .product .button' )
    .focus( function() {
        jQuery( this ).closest( '.product__cart-wrapper' ).addClass( 'focused' )
    })
    .blur( function() {
        jQuery( this ).closest( '.product__cart-wrapper' ).removeClass( 'focused' )
    })

jQuery(document).ready(function () {
    setTimeout( function(){
        jQuery('.instagram-feed__holder a').attr('tabindex', '-1')
    }, 1500 )
})

jQuery(document).on('click', '.shop__menu a', function (event) {
    event.preventDefault();

    jQuery('html, body').animate({
        scrollTop: jQuery(jQuery.attr(this, 'href')).offset().top
    }, 500);
})

// woo
jQuery(document).on('click', '.reset_variations', function (event) {

    jQuery( '.add_to_cart_button', jQuery( event.target ).closest('form') ).text('Select size')

})

jQuery(document).on('click', '.product_type_variation.add_to_cart_button', function (event) {

    event.preventDefault()

    jQuery( event.target ).addClass( 'loading' )

    var data = jQuery( event.target ).closest('form').serializeArray().reduce(function(obj, item) {
        obj[item.name] = item.value;
        return obj;
    }, {});

    data['action'] = 'dennis_variation_to_cart'

    console.log( data )

    jQuery.post( window.ajax_url, data, function( response ){

        if( response == 'success' ){

            jQuery( event.target ).removeClass( 'loading' )
            jQuery( event.target ).addClass( 'added' )
            jQuery( event.target ).text( 'Added' )

            setTimeout( function(){

                jQuery( event.target ).text( 'Add to cart' ).removeClass( 'added' )

            }, 5000 )

        }

    })

})
